// auth.js

import { useAuthStore } from '@/stores/authStore';
import ErrorHandler from '@/classes/ErrorHandler';

/**
 * Verifica se l'utente è loggato.
 *
 * Questa funzione è attesa dal navigation guard prima della prima navigazione: se
 * rigetta, `router.isReady()` non risolve e la form non viene mai montata. Per questo
 * qualsiasi errore viene assorbito e degradato a "non loggato" — l'utente vedrà la
 * versione pubblica della pagina invece di uno spinner infinito.
 */
export async function isLoggedIn(): Promise<boolean> {
	const authStore = useAuthStore();

	try {
		// richiamo i dati dell'utente, ogni volta
		await authStore.fetchUser();
	} catch (error) {
		ErrorHandler.addLog('isLoggedIn: fetchUser fallita, si prosegue come anonimo', error);
		return false;
	}

	// se i dati sono presenti, l'utente è "loggato"
	return authStore.isLoggedIn;
}
